import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getAllPayemntsApi, getAllSubscriptionApi } from "../utils/Constants";


export const getAllSubscriptions = createAsyncThunk("getAllSubscriptions", async () => {
    try {
        const token = localStorage.getItem("token");

        const config = {
            headers: { Authorization: token, "Access-Control-Allow-Origin": "*" },
        };
        const response = await axios.get(ApiBaseUrl + getAllSubscriptionApi, config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const getAllPayments = createAsyncThunk("getAllPayments", async () => {
    try {
        const token = localStorage.getItem("token");

        const config = {
            headers: { Authorization: token, "Access-Control-Allow-Origin": "*" },
        };
        const response = await axios.get(ApiBaseUrl + getAllPayemntsApi, config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

const GetProfileActivitySlice = createSlice({
    name: "profileActivity",

    initialState: {
        allSubscription: null,
        allPayments: null,
        isLoading: false,
        isError: false,
    },
    reducers: {
        clearGetProfileActivityData: (state) => {
            state.allSubscription = null;
            state.allPayments = null;
            state.isLoading = false;
            state.isError = false;
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(getAllSubscriptions.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllSubscriptions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allSubscription = action.payload;
            })
            .addCase(getAllSubscriptions.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })

            .addCase(getAllPayments.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllPayments.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allPayments = action.payload;
            })
            .addCase(getAllPayments.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })
    },
});

export const { clearGetProfileActivityData } = GetProfileActivitySlice.actions;
export default GetProfileActivitySlice.reducer;
